export default __webpack_public_path__ + "static/media/location-on.6a2065d3.svg";